import React, { useState, useEffect, useRef } from "react";

import { Spinner, Alert } from "react-bootstrap";
import Accordion from "react-bootstrap/Accordion";

import TrashIcon from "./img/trash.webp";

import Eskalationsdatum from "./Eskalationsdatum";
import KachelNotizMenu from "./KachelNotizMenu";
import KachelDateiMenu from "./KachelDateiMenu";
import KachelRestMenu from "./KachelRestMenu";
import KachelForm from "./KachelForm";
import ConfirmButton from "./ConfirmButton";
import { invisiblestring, statusfarben, eskalationsLevel } from "./globalVariables";
import { KachelEditForm } from "./KachelEdit";

function Kachel({
   allKacheln,
   setAllKacheln,
   sendData,
   data,
   changeData,
   eskstatus,
   setEskStatus,
   selectedkachel,
   changeEskStatus,
   layoutdata,
   loadSharepointData,
   createOOTask,
   estateId,
   loading,
   projektstufe,
   user,
   sharepointObject,
   sharepointIDs,
   notizen,
   fieldconfiguration,
   sendCommentsandNotes,
   handleElementBlock,
   currentElement,
   blockedField,
   teamsChannelNotification,
   userlist,
   userObjects,
   kachelAbschliessen,
   removeKachel,
}) {
   const [statusColor, setStatusColor] = useState("white");
   const [editLayout, setEditLayout] = useState(false);

   useEffect(() => {
      // Kachelvalidierung
      setStatusColor(
         eskstatus["kachel_status_" + layoutdata.kachelId] < eskalationsLevel &&
            layoutdata.pflichtEskalation &&
            new Date(eskstatus["kachel_eskalation_" + layoutdata.kachelId]) < new Date()
            ? "#c00"
            : statusfarben[eskstatus["kachel_status_" + layoutdata.kachelId]],
      );
   }, [data, eskstatus]);

   return (
      <Accordion.Item
         eventKey={layoutdata.kachelId}
         style={{
            ...(layoutdata.permittedUsers &&
            !(["globaladmin"].includes(user.role) || layoutdata.permittedUsers.includes(parseInt(user.id)))
               ? { opacity: 0.4, pointerEvents: "none" }
               : {}),
            ...(selectedkachel === layoutdata.kachelId
               ? {
                    transition: "border-color ease 0.7s",
                    border: `solid 4px ${statusColor}`,
                    borderRadius: "6px",
                 }
               : {
                    borderColor: "#dee2e6",
                    borderStyle: selectedkachel ? "none" : "solid",
                 }),
         }}
      >
         {eskstatus && (
            <Accordion.Header
               style={
                  selectedkachel != layoutdata.kachelId
                     ? { opacity: selectedkachel ? 0.3 : 1 }
                     : {
                          transition: "background-color ease 0.7s",
                          // borderTop: "solid white 10px",
                          zIndex: 4,
                          position: "sticky",
                          top: "-38px",
                          backgroundColor: statusColor,
                       }
               }
               bsPrefix={""}
            >
               <div
                  className="kachel-status"
                  style={{
                     transition: "background-color ease 1s",
                     backgroundColor: statusColor,
                  }}
               ></div>
               {eskstatus["kachel_status_" + layoutdata.kachelId] === 3 && (
                  <span
                     title="Freigabe durch Administrator erforderlich"
                     style={{ backgroundColor: "#000", color: "white" }}
                     className="pm-freigabe"
                  >
                     A
                  </span>
               )}
               {eskstatus["kachel_status_" + layoutdata.kachelId] === 2 && (
                  <span
                     title="Freigabe durch Projektmanager erforderlich"
                     style={{ backgroundColor: "#000", color: "white", width: "30px" }}
                     className="pm-freigabe"
                  >
                     P
                  </span>
               )}
               {!(
                  eskstatus["kachel_status_" + layoutdata.kachelId] === 2 ||
                  eskstatus["kachel_status_" + layoutdata.kachelId] === 3
               ) && (
                  <span className="pm-freigabe" style={{ width: "30px" }}>
                     {invisiblestring}
                  </span>
               )}

               {
                  <span
                     className="kachel-title"
                     style={{
                        padding: "4px 10px",
                        borderRadius: "4px",
                        fontWeight: layoutdata.pflichtKachel ? "900" : "500",
                        /* backgroundColor: "white", */
                        color: selectedkachel === layoutdata.kachelId ? statusColor : "black",
                     }}
                     title={layoutdata.pflichtKachel ? "Pflichtkachel" : "Optionale Kachel"}
                  >
                     {data["heading_" + layoutdata.kachelId]
                        ? data["heading_" + layoutdata.kachelId]
                        : layoutdata.heading}
                  </span>
               }
               {layoutdata.permittedUsers && (
                  <small>
                     {"Kachel nur für: "}
                     {layoutdata.permittedUsers
                        .map(
                           (userItem) =>
                              userObjects[userItem] &&
                              userObjects[userItem].Vorname + " " + userObjects[userItem].Nachname,
                        )
                        .join(", ")}
                  </small>
               )}
               {!selectedkachel && !layoutdata.notRemovable && (
                  <ConfirmButton
                     disabled={loading === "loading"}
                     myFunction={() => {
                        removeKachel(projektstufe, layoutdata.heading, layoutdata);
                     }}
                     myText={"Kachel entfernen: Kann wieder hergestellt werden und Inhalt bleibt erhalten"}
                     myName={""}
                     myIcon={TrashIcon}
                     renderDiv={true}
                     myStyle={{ position: "absolute", right: "10px", border: "none", top: "7px" }}
                     myClassName={"share-button"}
                  />
               )}
               {eskstatus["kachel_status_" + layoutdata.kachelId] < eskalationsLevel && (
                  <Eskalationsdatum
                     eskstatus={eskstatus}
                     setEskStatus={setEskStatus}
                     changeEskStatus={changeEskStatus}
                     kachelId={layoutdata.kachelId}
                     user={user}
                     estateId={estateId}

                     sendData={sendData}
                     userlist={userlist}
                     createOOTask={createOOTask}
                     sendCommentsandNotes={sendCommentsandNotes}

                  ></Eskalationsdatum>
               )}
            </Accordion.Header>
         )}
         {selectedkachel === layoutdata.kachelId && data && eskstatus && (
            <Accordion.Body /* style={editLayout ? { background: "#0001" } : {}} */>
               {editLayout && (
                  <KachelEditForm
                     data={layoutdata}
                     allKacheln={allKacheln}
                     setAllKacheln={setAllKacheln}
                     fieldconfiguration={fieldconfiguration}
                  />
               )}
               <div className="kachel-toolbar">
                  <KachelRestMenu
                     projektstufe={projektstufe}
                     layoutdata={layoutdata}
                     estateId={estateId}
                     removeKachel={removeKachel}
                     data={data}
                     changeData={changeData}
                     eskstatus={eskstatus}
                     kachelAbschliessen={kachelAbschliessen}
                     loading={loading}
                     editLayout={editLayout}
                     setEditLayout={setEditLayout}
                  />
                  <KachelDateiMenu
                     layoutdata={layoutdata}
                     sharepointObject={sharepointObject}
                     sharepointIDs={sharepointIDs}
                     loadSharepointData={loadSharepointData}
                     blockedField={blockedField}
                     currentElement={currentElement}
                     handleElementBlock={handleElementBlock}
                     user={user}
                     notizen={notizen}
                     sendCommentsandNotes={sendCommentsandNotes}
                     loading={loading}
                  />

                  <KachelNotizMenu
                     layoutdata={layoutdata}
                     estateId={estateId}
                     currentElement={currentElement}
                     blockedField={blockedField}
                     handleElementBlock={handleElementBlock}
                     user={user}
                     notizen={notizen}
                     sendCommentsandNotes={sendCommentsandNotes}
                     loading={loading}
                  />
               </div>

               {layoutdata.hinweis && (
                  <Alert variant="success" className="mt-2">
                     <span
                        className="tutorial-text"
                        dangerouslySetInnerHTML={{
                           __html: layoutdata.hinweis,
                        }}
                     />
                  </Alert>
               )}
               <KachelForm
                  allKacheln={allKacheln}
                  setAllKacheln={setAllKacheln}
                  sendData={sendData}
                  data={data}
                  changeData={changeData}
                  eskstatus={eskstatus}
                  changeEskStatus={changeEskStatus}
                  layoutdata={layoutdata}
                  createOOTask={createOOTask}
                  estateId={estateId}
                  loading={loading}
                  currentElement={currentElement}
                  user={user}
                  handleElementBlock={handleElementBlock}
                  blockedField={blockedField}
                  teamsChannelNotification={teamsChannelNotification}
                  userlist={userlist}
                  fieldconfiguration={fieldconfiguration}
                  editLayout={editLayout}
               />
            </Accordion.Body>
         )}
      </Accordion.Item>
   );
}

export default Kachel;
